module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/housekeeping/css/login.component.css
// module id = ./src/app/modules/housekeeping/css/login.component.css
// module chunks = main